/**
 * product-recommendations.js — نغمة ستور
 * ------------------------------------------------------------
 * توصيات منتجات حقيقية عبر Shopify Product Recommendations API. القسم
 * نفسه (sections/product-recommendations.liquid) يُرسَم فارغًا أول مرة لأن
 * recommendations.performed لا يُملأ فعليًا إلا عند طلب هذا القسم تحديدًا
 * عبر routes.product_recommendations_url (سلوك Shopify نفسه). هذا الملف
 * يطلب ذلك الرابط عبر Section Rendering API، ثم يستبدل محتوى الغلاف
 * بالكامل بما تُعيده Shopify فعليًا — فإن لم تُرجع أي توصية، يبقى القسم
 * فارغًا تمامًا (لا عنوان ولا شبكة فارغة)، تطابقًا مع متطلب الإخفاء الكامل
 * عند غياب التوصيات.
 *
 * تصحيح Product V5 (بند 9، تاريخي — استُبدلت آليته بالكامل في V7 أدناه):
 * كان WeakSet "initialized" يُعلِّم العنصر كمُهيَّأ نهائيًا فور بدء الطلب —
 * بصرف النظر عن نجاحه أو فشله — فلو فشل الطلب شبكيًا، يبقى العنصر "مُهيَّأ"
 * للأبد. أُضيف حينها pendingContainers (WeakSet) يُعلَّم فقط أثناء وجود
 * طلب قيد الانتظار فعليًا (يُزال فور الاستقرار)، وcontainerControllers
 * (WeakMap) لإلغاء الطلب صراحةً عند shopify:section:unload.
 *
 * تصحيح Product V6 (بند 4، تاريخي — استُبدلت آليته بالكامل في V7 أدناه):
 * عند تبديل المنتج المعروض عبر Combined Listing (applyProductSwap في
 * assets/product.js)، كان هذا القسم يبقى بلا أي علم بالتغيير. أُضيف مستمع
 * لحدث "naghmah:product-changed" يُحدِّث product_id داخل data-url لكل
 * عنصر [data-product-recommendations] موجود في الصفحة دون أي شرط.
 *
 * تصحيح Product V7 (بند 2 — إعادة بناء كاملة لآلية منع السباق): كانت
 * pendingContainers (WeakSet) وcontainerControllers (WeakMap) المنفصلتان
 * (V5) لا تكفيان لمنع كل سيناريوهات السباق الممكنة: لا وجود لعدّاد تسلسل
 * (sequence) يميّز صراحة "هذا الرد يخص أحدث طلب فعليًا"، ولا فحص لتطابق
 * data-url وقت الطلب مقابل وقت وصول الرد (فقد يتغيّر data-url نفسه أثناء
 * الانتظار عند تبديل منتج جديد قبل استقرار الرد السابق). الحل: حالة واحدة
 * موحدة (recommendationStates، WeakMap) لكل عنصر توصيات، تحمل:
 *   - sequence     : عدّاد يزداد مع كل طلب جديد لهذا العنصر تحديدًا.
 *   - controller    : AbortController الخاص بأحدث طلب قيد التنفيذ فعليًا.
 *   - requestedUrl  : قيمة data-url الدقيقة وقت *بدء* هذا الطلب تحديدًا.
 *   - pending       : true فقط أثناء انتظار رد هذا الطلب فعليًا.
 * قبل تطبيق أي HTML أو تصفير pending/controller، تُفحَص أربعة شروط معًا
 * (انظر isStillCurrent أدناه) — فلا يُطبَّق رد قديم أبدًا حتى لو وصل بعد
 * رد أحدث، ولا يُصفَّر pending/controller الخاصين بطلب أحدث فعلي من طلب
 * قديم كان لا يزال "يعتقد" أنه الأحدث وقت بدئه.
 *
 * تصحيح Product V7 (بند 3، جزئي — استُبدل بربط أدق في V8 أدناه): كان مستمع
 * "naghmah:product-changed" (V6) يُحدِّث كل عنصر [data-product-recommendations]
 * في الصفحة دون شرط. أُضيفت في V7 مطابقة data-product-id مقابل oldProductId
 * كحل أول — لكن هذا يفشل تحديدًا حين يعرض قسما Product مستقلان **نفس المنتج
 * بالضبط** (نادر لكن ممكن عبر محرر الثيم): كلا قسمي التوصيات يحملان نفس
 * data-product-id، فيتطابق الاثنان معًا مع oldProductId عند تغيّر أي منهما،
 * ويتحدّث قسم التوصيات "الخطأ" أيضًا رغم عدم انتمائه للقسم الذي تغيّر فعليًا.
 *
 * تصحيح Product V8 (بند 2 — ربط بنيوي عبر sourceSectionId بدل الاعتماد فقط
 * على productId): كل عنصر توصيات يُربَط الآن صراحة بمعرّف قسم Product الذي
 * "يقدّمه" فعليًا — عبر البحث للخلف بين إخوته (`.shopify-section` أشقاء)
 * حتى يجد أقرب قسم يحتوي [data-product-page]، وتُحفَظ قيمة data-section-id
 * الخاصة به في data-source-product-section-id على حاوية التوصيات (انظر
 * associateRecommendationsWithProduct أدناه). حدث "naghmah:product-changed"
 * (V7 بند 3، product.js) يحمل sourceSectionId — معرّف قسم Product الذي بدأ
 * التبديل تحديدًا — فتتم المطابقة الآن أولاً عبر data-source-product-section-id
 * مقابل sourceSectionId؛ لا يُعتمَد على oldProductId إلا حين لا يوجد ارتباط
 * مصدر صالح على الحاوية إطلاقًا (حالة احتياطية نادرة، مثلاً بنية DOM غير
 * معتادة لا يجدها البحث عن الأشقاء). هذا يضمن تمييز قسمي توصيات حتى لو
 * عرض قسما Product المرتبطان بهما نفس المنتج بالضبط.
 */
(function () {
  "use strict";

  window.Naghmah = window.Naghmah || {};
  var Naghmah = window.Naghmah;

  var recommendationStates = typeof WeakMap === "function" ? new WeakMap() : null;

  function getState(container) {
    if (!recommendationStates) return null;
    var state = recommendationStates.get(container);
    if (!state) {
      state = { sequence: 0, controller: null, requestedUrl: null, pending: false };
      recommendationStates.set(container, state);
    }
    return state;
  }

  /**
   * تصحيح Product V8 (بند 2): تربط حاوية توصيات بمعرّف قسم Product الذي
   * "يقدّمها" فعليًا — لا بمعرّف المنتج المعروض (قد يتشابه بين قسمين). تبحث
   * للخلف بين إخوة غلاف Shopify الخاص بهذا القسم (.shopify-section) حتى
   * تجد أقرب غلاف يحتوي [data-product-page]، وتقرأ data-section-id من ذلك
   * الجذر تحديدًا (لا من الغلاف نفسه) — نفس القيمة التي يبثّها product.js
   * كـsourceSectionId عند applyProductSwap. لا نتيجة (لا قسم Product سابق
   * يُعثر عليه بين الأشقاء) تعني عدم وجود ارتباط مصدر صالح — يبقى السلوك
   * الاحتياطي (مطابقة oldProductId) هو ما يُستخدَم حينها عند الحدث.
   */
  function associateRecommendationsWithProduct(container) {
    var wrapper = container.closest(".shopify-section");
    if (!wrapper) return;

    var sibling = wrapper.previousElementSibling;
    while (sibling) {
      var productPage =
        sibling.matches && sibling.matches("[data-product-page]")
          ? sibling
          : sibling.querySelector
          ? sibling.querySelector("[data-product-page]")
          : null;
      if (productPage) {
        var sectionId = productPage.getAttribute("data-section-id");
        if (sectionId) {
          container.setAttribute("data-source-product-section-id", sectionId);
        }
        return;
      }
      sibling = sibling.previousElementSibling;
    }
  }

  /**
   * تصحيح Product V7 (بند 2): الفحوص الإلزامية الأربعة قبل تطبيق أي رد أو
   * تصفير حالة "قيد الانتظار" لهذا الطلب تحديدًا. أي فحص يفشل يعني أن هذا
   * الرد لم يعد يستحق أي أثر فعلي على الصفحة أو على حالة العنصر:
   *   1) requestId يطابق أحدث sequence لهذا العنصر (لا طلب أحدث بدأ بعده).
   *   2) العنصر لا يزال في DOM فعليًا.
   *   3) data-url الحالي على العنصر لا يزال يطابق requestedUrl المحفوظة
   *      وقت بدء هذا الطلب تحديدًا (يكشف تبديل منتج جديد أثناء الانتظار
   *      حتى لو لم يتغيّر sequence بعد لأي سبب).
   *   4) Controller الحالي المسجَّل في الحالة هو تحديدًا Controller هذا
   *      الطلب (لم يُستبدَل بطلب أحدث بالفعل).
   */
  function isStillCurrent(container, state, requestId, controller) {
    if (!state) return true; // لا WeakMap متاحة (بيئة قديمة جدًا) — لا حماية سباق ممكنة أصلاً
    if (state.sequence !== requestId) return false;
    if (!document.body.contains(container)) return false;
    if (container.getAttribute("data-url") !== state.requestedUrl) return false;
    if (state.controller !== controller) return false;
    return true;
  }

  function fetchAndApply(container, url, controller, requestId, state) {
    var signal = controller ? controller.signal : undefined;

    fetch(url, { headers: { Accept: "text/html" }, signal: signal })
      .then(function (res) {
        return res.ok ? res.text() : null;
      })
      .then(function (html) {
        if (!isStillCurrent(container, state, requestId, controller)) return; // رد قديم — لا تصفير ولا تطبيق
        if (state) state.pending = false;
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newContainer = container.id ? doc.getElementById(container.id) : null;
        if (!newContainer) return;
        container.innerHTML = newContainer.innerHTML;
      })
      .catch(function (err) {
        if (!isStillCurrent(container, state, requestId, controller)) return; // خطأ لطلب قديم — لا تصفير حالة طلب أحدث
        if (state) state.pending = false;
        if (err && err.name === "AbortError") return; // أُلغي عمدًا — لا شيء يستحق المعالجة
        /* فشل شبكي حقيقي — يبقى القسم فارغًا (مطابق لسلوك "إخفاء كامل عند
           غياب التوصيات")، ويمكن إعادة المحاولة لاحقًا فعليًا عبر أي نداء
           initSection جديد لهذا العنصر (pending أُعيدت false أعلاه). */
      });
  }

  function loadRecommendations(container) {
    var url = container.getAttribute("data-url");
    if (!url) return;

    // تصحيح Product V8 (بند 2): احتياط دفاعي — لو استُدعيت هذه الدالة قبل أي
    // تهيئة صريحة (initSection) أو تحميل (shopify:section:load) حصل فيها
    // الربط بالفعل، تُحاول هنا مرة أخيرة قبل بدء الطلب.
    if (!container.getAttribute("data-source-product-section-id")) {
      associateRecommendationsWithProduct(container);
    }

    var state = getState(container);

    // تصحيح Product V7 (بند 2): إلغاء أي طلب سابق قيد الانتظار لنفس العنصر
    // قبل بدء طلب جديد — بصرف النظر عمّا إذا كان لا يزال pending أم لا،
    // فلا يوجد سيناريو صحيح لطلبين متزامنين فعليين لنفس العنصر.
    if (state && state.controller) {
      try {
        state.controller.abort();
      } catch (err) {
        /* لا شيء يستحق المعالجة. */
      }
    }

    var requestId = state ? (state.sequence += 1) : 0;
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    if (state) {
      state.requestedUrl = url;
      state.pending = true;
      state.controller = controller;
    }

    fetchAndApply(container, url, controller, requestId, state);
  }

  function initSection(sectionEl) {
    var container =
      sectionEl && sectionEl.matches && sectionEl.matches("[data-product-recommendations]")
        ? sectionEl
        : sectionEl
        ? sectionEl.querySelector("[data-product-recommendations]")
        : document.querySelector("[data-product-recommendations]");
    if (!container) return;
    associateRecommendationsWithProduct(container);
    loadRecommendations(container);
  }

  /* تصحيح Product V8 (بند 2): shopify:section:load يُطلَق أيضًا عند إضافة/
     نقل/إعادة ترتيب أقسام داخل محرر الثيم — ترتيب الأشقاء قد يتغيّر، فيُعاد
     حساب data-source-product-section-id من الصفر في كل مرة (لا يُكتفى
     بوجود قيمة سابقة قد تخص ترتيبًا سابقًا لم يعد صحيحًا). */
  document.addEventListener("shopify:section:load", function (event) {
    var wrapper = event.target;
    if (!wrapper || !wrapper.querySelector) return;
    var container = wrapper.querySelector("[data-product-recommendations]");
    if (!container) return;
    associateRecommendationsWithProduct(container);
  });

  /* إلغاء الطلب الخاص بقسم توصيات مُزال تحديدًا — لا يؤثر على أي عنصر
     توصيات آخر (كل عنصر يحمل حالته المستقلة عبر recommendationStates). */
  document.addEventListener("shopify:section:unload", function (event) {
    var wrapper = event.target;
    if (!wrapper || !wrapper.querySelector || !recommendationStates) return;
    var container = wrapper.querySelector("[data-product-recommendations]");
    if (!container) return;
    var state = recommendationStates.get(container);
    if (state && state.controller) {
      try {
        state.controller.abort();
      } catch (err) {
        /* لا شيء يستحق المعالجة — القسم يُزال أصلاً. */
      }
    }
  });

  /* تصحيح Product V7 (بند 3): يُبَث من assets/product.js (applyProductSwap)
     فور استبدال [data-product-page] بالكامل بمنتج شقيق ضمن Combined
     Listing. يحدَّث فقط عنصر التوصيات الذي كانت data-product-id عليه
     تطابق detail.oldProductId تحديدًا — أي العنصر الذي كان يخصّ فعليًا
     المنتج الذي غادرته الصفحة، لا كل عنصر توصيات موجود دون شرط. */
  document.addEventListener("naghmah:product-changed", function (event) {
    var detail = event && event.detail;
    if (!detail || !detail.productId) return;

    document.querySelectorAll("[data-product-recommendations]").forEach(function (container) {
      // تصحيح Product V8 (بند 2): المطابقة الأساسية عبر data-source-product-
      // section-id مقابل sourceSectionId — معرّف قسم Product الذي بدأ
      // التبديل تحديدًا. لا يُعتمَد على oldProductId إلا حين لا يحمل هذا
      // العنصر ارتباط مصدر صالح إطلاقًا (احتياطي نادر). هذا يميّز بين قسمي
      // توصيات حتى لو عرض قسما Product المرتبطان بهما نفس المنتج بالضبط.
      var sourceSectionId = container.getAttribute("data-source-product-section-id");
      var matchesThisContainer;
      if (sourceSectionId) {
        matchesThisContainer = Boolean(detail.sourceSectionId) && sourceSectionId === detail.sourceSectionId;
      } else {
        var containerProductId = container.getAttribute("data-product-id");
        matchesThisContainer =
          Boolean(containerProductId) && Boolean(detail.oldProductId) && containerProductId === detail.oldProductId;
      }
      if (!matchesThisContainer) return; // ليس هذا العنصر

      var currentUrl = container.getAttribute("data-url");
      if (!currentUrl) return;

      var nextUrl;
      try {
        nextUrl = new URL(currentUrl, window.location.origin);
      } catch (err) {
        return; // رابط غير صالح لحالة نادرة — لا يستحق كسر بقية المعالجة
      }
      nextUrl.searchParams.set("product_id", detail.productId);

      // تحديث هوية العنصر نفسه لتصبح المنتج الجديد — طلبات لاحقة (تبديل
      // آخر) ستقارن بهذه القيمة الجديدة، لا القديمة.
      container.setAttribute("data-product-id", detail.productId);
      container.setAttribute("data-url", nextUrl.pathname + nextUrl.search);

      // مسح أي نتائج قديمة ظاهرة فورًا — لا تبقى توصيات المنتج السابق
      // معروضة أثناء انتظار توصيات المنتج الجديد أو بعد فشل طلبها.
      var oldInner = container.querySelector(".product-recommendations__inner");
      if (oldInner) oldInner.remove();

      // loadRecommendations تُلغي داخليًا أي طلب سابق قيد الانتظار لهذا
      // العنصر (كان يخص المنتج القديم) وتبدأ طلبًا واحدًا جديدًا فقط.
      loadRecommendations(container);
    });
  });

  if (Naghmah.registerSection) {
    Naghmah.registerSection("product-recommendations", initSection);
  }

  Naghmah.onReady(function () {
    /* تصحيح Product V4 (بند 8): نفس تصحيح product.js — قد يوجد أكثر من
       قسم توصيات محفوظ داخل القالب (تكرار متعمَّد أو أثناء تحرير محرر
       الثيم)؛ querySelector وحدها كانت تُهيّئ أول قسم فقط. */
    document.querySelectorAll("[data-product-recommendations]").forEach(function (container) {
      initSection(container);
    });
  });
})();
